'use client';

import { createContext, useContext, useMemo } from 'react';

// Names the list its children belong to, so a product card can report
// `item_list_id` / `item_list_name` without every surface threading the same two
// props down through its sliders and grids.
const ProductListContext = createContext(null);

/**
 * @param {object} list      `{ item_list_id, item_list_name }` from `item-lists.js`
 * @param {string|number} viewKey  changes when the list is re-rendered with a
 *   different result set (a PLP page number), making its items eligible again
 */
export const ProductListProvider = ({ list, viewKey = '', children }) => {
  const id = list?.item_list_id;
  const name = list?.item_list_name;

  const value = useMemo(
    () =>
      id
        ? {
            list: { item_list_id: id, ...(name && { item_list_name: name }) },
            viewKey: String(viewKey ?? ''),
          }
        : null,
    [id, name, viewKey]
  );

  return (
    <ProductListContext.Provider value={value}>
      {children}
    </ProductListContext.Provider>
  );
};

export const useProductList = () => useContext(ProductListContext);
